__turbopack_context__.v({
  "content": "Content-module__rHaCIa__content",
});
